const getters = {
    GET_BANKS: (state) => state.banks,
}

export default getters
